<template>
    <section class="section">
        <div class="container">
            <br>
            <br>
            <div class="columns">
                <div class="column is-half p-4">
                    <div class="content">
            <h3 class="is-size-3 has-text-primary section-title">Explore an Asset Finance Funding Solution</h3>
                        <br>
                        <p class="">WebBank is a leading player in the digital lending space, providing funding to both third party finance companies as well as our Strategic Partner platforms. We finance a full range of asset types through senior secured, asset-backed credit facilities, including consumer installment loans, consumer lines of credit, credit cards, BNPL, SMB loans, merchant cash advances, equipment loans, and more.</p>
                        <br>
                        <p>We work with experienced originators with a track record of growth. Our loan commitments typically range between $30 - $60 million, with larger syndicated solutions available for established companies.</p>
                        <br>
                        <p>To learn how we may work together, please share your information by completing and submitting the form.</p>
                    </div>
                    <br>
                </div>
                <div class="column p-4">

            <section class="section" v-if="success">
                <div class="container">
                    <div class="columns">
                        <div class="column is-8 is-offset-2 has-text-centered">
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <span class="icon has-text-success"><i class="fa-solid fa-badge-check fa-10x"></i></span>
                            <br>
                            <br>
                            <br>
                            <br>
                            <p class="has-text-success is-size-3">Thank you! Your message has been sent!</p>
                            <br>
                            <br>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </section>

                    <div class="has-text-centered">
                        <h3 class="is-size-3 has-text-primary section-title">Let's Work Together</h3>
                        <br>
                        <p>Interested in learning more about an Asset Finance solution with WebBank? Complete the form and someone from our team will reach out to you to start a conversation. </p>
                    </div>
                    <br>
                    <br>

                    <div class="notification is-danger" v-if="captcha_error">
                        Captcha verification failed. Please try again.
                    </div>

                    <div class="notification is-danger" v-if="errors && errors.fields">
                        Please check your input and try again.
                    </div>

                    <Form @submit="submitForm" :validation-schema="yupSchema">
                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">First Name</label>
                                    <div class="control">
                                        <Field class="input" type="text" placeholder="John" name="first_name" />
                                    </div>
                                    <ErrorMessage name="first_name" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('first_name')"
                                        class="help has-text-danger">
                                        {{ errors.messages.first_name.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Last Name</label>
                                    <div class="control">
                                        <Field class="input" type="text" placeholder="Doe" name="last_name" />
                                    </div>
                                    <ErrorMessage name="last_name" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('last_name')"
                                        class="help has-text-danger">
                                        {{ errors.messages.last_name.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Email</label>
                                    <div class="control has-icons-left has-icons-right">
                                        <Field class="input" type="email" name="email" placeholder="me@mycompany.com" />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-envelope"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage name="email" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('email')"
                                        class="help has-text-danger">
                                        {{ errors.messages.email.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Phone</label>
                                    <div class="control">
                                        <Field class="input" v-maska:[options] type="tel" name="phone"
                                            placeholder="xxx-xxx-xxxx" />
                                    </div>
                                    <ErrorMessage name="phone" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('phone')"
                                        class="help has-text-danger">
                                        {{ errors.messages.phone.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Company Name</label>
                                    <div class="control">
                                        <Field class="input" type="text" name="company_name" placeholder="My Company" />
                                    </div>
                                    <ErrorMessage name="company_name" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('company_name')"
                                        class="help has-text-danger">
                                        {{ errors.messages.company_name.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Website</label>
                                    <div class="control">
                                        <Field class="input" type="text" name="website"
                                            placeholder="https://mycompany.com" />
                                    </div>
                                    <ErrorMessage name="website" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('website')"
                                        class="help has-text-danger">
                                        {{ errors.messages.website.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Number of Employees</label>
                                    <div class="control">
                                        <Field class="input" type="text" inputmode="numeric" name="number_employees"
                                            placeholder="1" v-maska:[number_options] />
                                    </div>
                                    <ErrorMessage name="number_employees" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('number_employees')"
                                        class="help has-text-danger">
                                        {{ errors.messages.number_employees.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Years in Business</label>
                                    <div class="control">
                                        <Field class="input" type="text" inputmode="numeric" name="years_in_business"
                                            placeholder="1" v-maska:[number_options] />
                                    </div>
                                    <ErrorMessage name="years_in_business" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('years_in_business')"
                                        class="help has-text-danger">
                                        {{ errors.messages.years_in_business.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Annual Revenue</label>
                                    <div class="control has-icons-left">
                                        <Field class="input" type="text" inputmode="numeric" name="annual_revenue"
                                            placeholder="xxxxxx" v-maska:[number_options] />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage name="annual_revenue" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('annual_revenue')"
                                        class="help has-text-danger">
                                        {{ errors.messages.annual_revenue.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Last 12 Months Origination Volume</label>
                                    <div class="control has-icons-left">
                                        <Field class="input" type="text" inputmode="numeric" name="origination_volume"
                                            placeholder="xxxxxx" v-maska:[number_options] />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage name="origination_volume" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('origination_volume')"
                                        class="help has-text-danger">
                                        {{ errors.messages.origination_volume.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Total Capital Raised</label>
                                    <div class="control has-icons-left">
                                        <Field class="input" type="text" inputmode="numeric"
                                            name="total_capital_raised" placeholder="xxxxxx"
                                            v-maska:[number_options] />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage name="total_capital_raised" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('total_capital_raised')"
                                        class="help has-text-danger">
                                        {{ errors.messages.total_capital_raised.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Date of Most Recent Capital Raise</label>
                                    <div class="control">
                                        <Field class="input" type="date" inputmode="date" name="recent_capital_date"
                                            placeholder="xx/xx/xxxx" />
                                    </div>
                                    <ErrorMessage name="recent_capital_date" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('recent_capital_date')"
                                        class="help has-text-danger">
                                        {{ errors.messages.recent_capital_date.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label class="label">Asset Type</label>
                                    <div class="control">
                                        <div class="select is-fullwidth">
                                            <Field as="select" name="asset_type">
                                                <option value="">Select one...</option>
                                                <option value="auto">Auto</option>
                                                <option value="commercial_insurance_premium">Commercial Insurance Premium</option>
                                                <option value="consumer_litigation_finance">Consumer Litigation Finance</option>
                                                <option value="credit_card">Credit Card</option>
                                                <option value="floorplan_loans">Floorplan Loans</option>
                                                <option value="home_improvement_loans">Home Improvement Loans</option>
                                                <option value="invoice_financing">Invoice Financing</option>
                                                <option value="merchant_cash_advances">Merchant Cash Advances</option>
                                                <option value="middle_market_loans">Middle Market Loans</option>
                                                <option value="payroll_deduction_loans">Payroll Deduction Loans</option>
                                                <option value="personal_loans">Personal Loans</option>
                                                <option value="point_of_sale_finance">Point of Sale Finance</option>
                                                <option value="powersports">Powersports</option>
                                                <option value="secured_card">Secured Card</option>
                                                <option value="small_ticket_equipment">Small Ticket Equipment</option>
                                                <option value="smb_loans">SMB Loans</option>
                                                <option value="student_loans">Student Loans</option>
                                                <option value="trade_receivables">Trade Receivables</option>
                                                <option value="wage_advance">Wage Advance</option>
                                                <option value="other">Other</option>
                                            </Field>
                                        </div>
                                    </div>
                                    <ErrorMessage name="asset_type" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('asset_type')"
                                        class="help has-text-danger">
                                        {{ errors.messages.asset_type.join(', ') }}
                                    </p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <label class="label">Current Portfolio Size</label>
                                    <div class="control has-icons-left">
                                        <Field class="input" type="text" inputmode="numeric" name="portfolio_size"
                                            placeholder="xxxxxx" v-maska:[number_options] />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage name="portfolio_size" class="help has-text-danger" />
                                    <p v-if="errors && errors.fields && errors.fields.includes('portfolio_size')"
                                        class="help has-text-danger">
                                        {{ errors.messages.portfolio_size.join(', ') }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Current Funding Strategy /Other </label>
                            <div class="control">
                                <Field class="textarea" as="textarea" name="funding_strategy"
                                    placeholder="Additional Details">
                                </Field>
                            </div>
                            <ErrorMessage name="funding_strategy" class="help has-text-danger" />
                            <p v-if="errors && errors.fields && errors.fields.includes('funding_strategy')"
                                class="help has-text-danger">
                                {{ errors.messages.funding_strategy.join(', ') }}
                            </p>
                        </div>

                        <div class="field is-grouped">
                            <div class="control">
                                <button class="button is-primary" type="submit"
                                    :class="{ 'is-loading': sending }">Submit</button>
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        </div>
    </section>

</template>

<script>
import axios from 'axios';
import { vMaska } from "maska"
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';

export default {
    directives: { maska: vMaska },
    components: {
        Form,
        Field,
        ErrorMessage,
    },

    setup() {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        const urlRegex = /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?$/;
        const yupSchema = yup.object().shape({
            first_name: yup.string().required().min(3).max(100).label('First Name'),
            last_name: yup.string().required().min(3).max(100).label('Last Name'),
            email: yup.string().required().matches(emailRegex, 'Invalid email format').label('Email'),
            phone: yup.string().required().min(12).max(12).label('Phone'),
            company_name: yup.string().required().min(3).max(100).label('Company Name'),
            website: yup
                        .string()
                        .transform((value, originalValue) => {
                            const trimmedValue = String(originalValue).trim();
                            return trimmedValue === "" ? undefined : trimmedValue;
                        })
                        .required('Website is required')
                        .matches(urlRegex, 'Invalid url format')
                        .max(100)
                        .label('Website'),
            number_employees: yup
                            .number('Number of Employees must be a number')
                            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value)
                            .required('Number of Employees is required')
                            .positive('Number of Employees must be a positive number')
                            .integer('Number of Employees must be an integer')
                            .label('Number of Employees'),
            years_in_business: yup
                            .number('Years in Business must be a number')
                            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value)
                            .required('Years in Business is required')
                            .positive('Years in Business must be a positive number')
                            .integer('Years in Business must be an integer')
                            .min(1, 'Years in Business must be at least 1')
                            .max(100, 'Years in Business must be less than 100')
                            .label('Years in Business'),
            annual_revenue: yup
                            .number('Annual Revenue must be a number')
                            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value)
                            .required('Annual Revenue is required')
                            .positive('Annual Revenue must be a positive number')
                            .integer('Annual Revenue must be an integer')
                            .label('Annual Revenue'),
            origination_volume: yup
                            .number('Last 12 Months Origination Volume must be a number')
                            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value)
                            .required('Last 12 Months Origination Volume is required')
                            .positive('Last 12 Months Origination Volume must be a positive number')
                            .integer('Last 12 Months Origination Volume must be an integer')
                            .label('Last 12 Months Origination Volume'),
            total_capital_raised: yup
                            .number('Total Capital Raised must be a number')
                            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value)
                            .required('Total Capital Raised is required')
                            .positive('Total Capital Raised must be a positive number')
                            .integer('Total Capital Raised must be an integer')
                            .label('Total Capital Raised'),
            recent_capital_date: yup
                            .date()
                            .transform((value, originalValue) => {
                                const stringValue = originalValue != null ? String(originalValue).trim() : "";
                                if (stringValue === "" || isNaN(new Date(stringValue).getTime())) {
                                    return undefined;
                                }
                                const dateValue = new Date(stringValue);
                                return !isNaN(dateValue.getTime()) ? dateValue : undefined;
                            })
                            .required('Date of Most Recent Capital Raise is required')
                            .max(new Date())
                            .label('Date of Most Recent Capital Raise'),
            asset_type: yup.string().required().label('Asset Type'),
            portfolio_size: yup
                .number('Current Portfolio Size must be a number')
                .transform((value, originalValue) => originalValue === '' ? undefined : value)
                .required('Current Portfolio Size is required')
                .positive('Current Portfolio Size must be a positive number')
                .integer('Current Portfolio Size must be an integer')
                .label('Current Portfolio Size'),
            funding_strategy: yup.string().required().min(3).max(1000).label('Current Funding Strategy')
        });
        return { yupSchema };
    },

    created() {
        document.title = "Asset Finance - WebBank";
    },

    data: function () {
        return {
            sending: false,
            success: false,
            errors: [],
            captcha_error: null,
            options: {
                mask: "###-###-####",
                eager: false,
            },
            number_options: {
                mask: "##########",
                eager: false,
                reversed: true,
            },
        }
    },

    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },

    methods: {
        submitForm: function (values) {
            this.errors = [];
            this.sending = true;

            this.$recaptcha('specialty_finance_form')
                .then(token => {
                    // You can now use this token to verify the captcha response on your server
                    // console.log(token);
                    values['form_name'] = 'specialty_finance';
                    values['g-recaptcha-response'] = token;
                    let convert = ['number_employees', 'years_in_business', 'annual_revenue', 'origination_volume', 'total_capital_raised', 'portfolio_size'];
                    convert.forEach((key) => {
                        values[key] = parseInt(values[key]);
                    });
                    console.log('posting values: ' + JSON.stringify(values));
                    axios.post(process.env.VUE_APP_MAIL_ENDPOINT, values)
                        .then(result => {
                            console.log('result: ' + JSON.stringify(result));
                            this.success = true;
                        }).catch(error => {
                            console.log('error: ' + JSON.stringify(error));
                            if (error.response.status === 403) {
                                this.captcha_error = error.message;
                            } else {
                                // can I still reach the "body" of the response?
                                console.log('error.body: ' + JSON.stringify(error.response.data));
                                this.errors = this.processErrors(error.response.data);
                                // console.log('ERRORS: ' + JSON.stringify(this.errors));
                            }
                        }).finally(() => this.sending = false);
                });
        },
        processErrors: function (apiResponse) {
            const errors = {
                fields: Object.keys(apiResponse), // Array of field names with errors
                messages: apiResponse // Keep the original structure for message access
            };
            return errors;
        }

    }
}
</script>
